var map = {
	"./logo-game.png": 75,
	"./logo-game@2x.png": 76
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 193;



//////////////////
// WEBPACK FOOTER
// ./themes/mf/img ^\.\/logo\-game.*\.png$
// module id = 193
// module chunks = 3